// extracted by mini-css-extract-plugin
export default {"wrapper":"InvoicesChart_wrapper__WH1VC","gradient":"InvoicesChart_gradient__A71AZ","shine-lines":"InvoicesChart_shine-lines__YYPbx","title":"InvoicesChart_title__b8fo6"};